export default class Signup
{
    constructor() {
      this.full_name = ''
      this.email = ''
      this.company = ''
      this.password = ''
      this.password_confirmation = ''
    }
}